<div class="full-size form justify-content-center align-items-center">
    <vega-icon class="error-icon" iconName="error-filled"></vega-icon>
    <div class="flex">
        <h1>{{ "PAGENOTFOUND.MESSAGE" | translate }}</h1>
        <h2>{{ "PAGENOTFOUND.MESSAGEEXPLANATION" | translate }}</h2>
    </div>
</div>
